<template>
  <div>

    <account-limitation-for-more-monitor-refresh-notification></account-limitation-for-more-monitor-refresh-notification>
    <account-required-for-more-checks-notification></account-required-for-more-checks-notification>
    <payment-required-for-more-checks-notification></payment-required-for-more-checks-notification>

    <account-limitation-for-more-checks-notification></account-limitation-for-more-checks-notification>

    <payment-required-for-more-monitor-refresh-notification></payment-required-for-more-monitor-refresh-notification>
    <payment-required-for-more-monitors-notification></payment-required-for-more-monitors-notification>
  </div>
</template>

<script>
import AccountRequiredForMoreChecksNotification from './AccountRequiredForMoreChecksNotification'
import AccountLimitationForMoreChecksNotification from './AccountLimitationForMoreMonitorRefreshNotification'
import AccountLimitationForMoreMonitorRefreshNotification from './AccountLimitationForMoreMonitorRefreshNotification'
import PaymentRequiredForMoreMonitorRefreshNotification from './PaymentRequiredForMoreMonitorRefreshNotification'
import PaymentRequiredForMoreMonitorsNotification from './PaymentRequiredForMoreMonitorsNotification'
import PaymentRequiredForMoreChecksNotification from './PaymentRequiredForMoreChecksNotification'

export default {
  name: 'AppNotifications',
  components: {
    PaymentRequiredForMoreChecksNotification,
    PaymentRequiredForMoreMonitorsNotification,
    AccountRequiredForMoreChecksNotification,
    AccountLimitationForMoreChecksNotification,
    PaymentRequiredForMoreMonitorRefreshNotification,
    AccountLimitationForMoreMonitorRefreshNotification,
  },
}
</script>